export const DATE_FORMAT_CATEGORY = 'MMM DD, YYYY'; // e.g., "Jan 01, 2024"
export const DATE_FORMAT_FULL = 'MMMM D, YYYY'; // e.g., "January 1, 2024"
